export enum TipologiaQuestionario {
  cognitivo = 'COGNITIVO',
  nonCognitivo = 'NON-COGNITIVO',
}
